import { useState } from "react";
import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { SITE } from "@/data/site";

export default function Contact() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) return toast.error("Please enter your name and phone");
    await api.post("/leads", { ...form, source: "Website" });
    toast.success("Thank you! We'll get back to you shortly.");
    setForm({ name: "", phone: "", email: "", message: "" });
  };
  const items = [
    { icon: Phone, label: "Phone", value: `${SITE.phone}, ${SITE.phone2}` },
    { icon: MessageCircle, label: "WhatsApp", value: SITE.phone2 },
    { icon: Mail, label: "Email", value: SITE.email },
    { icon: MapPin, label: "Office", value: SITE.address },
    { icon: Clock, label: "Working Hours", value: SITE.hours },
  ];
  return (
    <div className="font-body">
      <div className="bg-[#08341f] py-16 text-center text-white">
        <p className="text-sm uppercase tracking-[0.25em] text-[#D4AF37] font-semibold">Contact</p>
        <h1 className="font-heading text-4xl lg:text-5xl font-bold mt-3">Let's Talk Plots</h1>
      </div>
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-14 grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div className="space-y-4">
          {items.map((it) => (
            <div key={it.label} className="flex items-start gap-4 rounded-xl border border-gray-100 p-5">
              <span className="grid place-items-center w-11 h-11 rounded-full bg-[#0B5D3B]/10 text-[#0B5D3B]"><it.icon size={20}/></span>
              <div><p className="text-xs uppercase tracking-wide text-gray-400">{it.label}</p><p className="font-medium text-gray-800">{it.value}</p></div>
            </div>
          ))}
        </div>
        <form onSubmit={submit} className="rounded-2xl border border-gray-100 p-8 space-y-4" data-testid="contact-form">
          <h3 className="font-heading text-xl font-bold text-gray-900">Send us a message</h3>
          <input data-testid="contact-name" value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})} placeholder="Full Name" className="w-full rounded-lg border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#0B5D3B]"/>
          <input data-testid="contact-phone" value={form.phone} onChange={(e)=>setForm({...form,phone:e.target.value})} placeholder="Phone Number" className="w-full rounded-lg border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#0B5D3B]"/>
          <input data-testid="contact-email" value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})} placeholder="Email (optional)" className="w-full rounded-lg border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#0B5D3B]"/>
          <textarea data-testid="contact-message" value={form.message} onChange={(e)=>setForm({...form,message:e.target.value})} placeholder="Your Message" rows={4} className="w-full rounded-lg border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#0B5D3B]"/>
          <button data-testid="contact-submit" className="w-full rounded-full bg-[#0B5D3B] text-white py-3.5 font-semibold hover:bg-[#094e32] transition-colors">Send Message</button>
        </form>
      </div>
    </div>
  );
}
